import { Box, Button, Paper, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'

/** Outbound links from emails land here first so users can see where they're going. */
export function LinkWarning() {
  const [params] = useSearchParams()
  const raw = params.get('u') ?? ''
  let url: URL | null = null
  try { const u = new URL(raw); if (u.protocol === 'http:' || u.protocol === 'https:') url = u } catch { /* invalid */ }
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100%', p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 560 }}>
        <Typography variant="h6" gutterBottom>You are leaving Orbimail</Typography>
        {url ? (
          <>
            <Typography color="text.secondary" gutterBottom>This link was in an email. Only continue if you trust the sender.</Typography>
            <Typography sx={{ wordBreak: 'break-all', my: 2, fontFamily: 'monospace' }}>{url.href}</Typography>
            <Button variant="contained" href={url.href} rel="noopener noreferrer nofollow" referrerPolicy="no-referrer">Continue to {url.hostname}</Button>
          </>
        ) : (
          <Typography color="error">That link isn't safe to open.</Typography>
        )}
      </Paper>
    </Box>
  )
}
